<div class="container-fluid" style="padding-top: 40px">
    <!------------------------ Search Filters ----------------------------------->
    <div class="row search_filters" style="margin-bottom: 20px;">
        <div class="col-md-2">
            <div class=" p-3 "> 
                <div style="width: 100%;"> 
                    <select style="border: transparent; outline: none; width: 100%;" [ngModel]="selectedCity" (ngModelChange)="changeCity($event)">
                        <option value="city" disabled class="search_location">City </option>
                        <option *ngFor="let x of citySel" [ngValue]="x.id">{{x.text}} </option>
                    </select>
                </div>     
            </div>
        </div>
        <div class="col-md-3">
            <div class=" p-3 "> 
                <div style="width: 100%;"> 
                    <input style="border: transparent; outline: none; width: 100%;" [ngModel]="addressActive" (ngModelChange)="addressActive = $event" placeholder="Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control" #search >
                </div>    
            </div>
        </div>
        <div class="col-md-2"> 
            <div class=" p-3 ">                
                <div> 
                    <select style="border: transparent; outline: none; width: 100%;" [ngModel]="selectedRadius" (ngModelChange)="changeRadius($event)">
                        <option value="0" disabled class="search_radius">Radius (in Km) </option>
                        <option *ngFor="let x of radiusSel" [ngValue]="x.id">{{x.text}} </option>
                    </select>
                </div>    
            </div>
        </div>
        <div class="col-md-2">
            <div class=" p-3 "> 
                <div> 
                    <select style="border: transparent; outline: none; width: 100%;" [ngModel]="selectedGender" (ngModelChange)="changeGender($event)">
                        <option value="0" disabled class="search_gender">Gender </option>
                        <option *ngFor="let x of genderSel" [ngValue]="x.id">{{x.text}} </option>
                    </select>
                </div>    
            </div>
        </div>
        
    </div>
</div>
<div class="container" style="padding-top: 40px">
    <!------------------------ Search Filters Ends here ---------------------->
    <!-------------------------------- Search filter for smaller devices starts here -------------------->
    <div class="search_filters_sm">
        <button type="button" class="btn btn-info"> Filters </button>
    </div>
    <!--------------------------------------- Search Filter for smaller devices ends here -------------->
    <div *ngIf="loader == true" style="height: 80vh; display: flex; justify-content: center; align-items: center;">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <h2 *ngIf="loader == false" class="mb-4"> {{ totalProperty }} properties found in <span style="text-transform: capitalize; font-weight: 500;">{{addressActive}} </span></h2> 
    
    <div class="row" style="margin: auto;" *ngIf="loader == false">

        <div class="col-md-12 col-lg-9" >
            <div class="row prop_holder justify-content-sm-center justify-content-md-between" >
                <div class="prop_card col-md-6 col-lg-6" *ngFor="let prop of propertyData; let i = index;">
                    <div  class="propertyList" [routerLink]="['/property', prop.property.id]" >
                        <div style="overflow: hidden;" >
                            <img [ngStyle]="{'filter' : prop.property.status == 'occupied' ? 'grayscale(1)':'grayscale(0)'}" class="prop_card_img"*ngIf="prop.property.image != null" src="{{ prop.property.image.url }}" >
                            <img *ngIf="prop.property.image == null" src="assets/images/coming-soon.png" class="p-4" style="width: 100%; height: 100%;">
                        </div>
                        <div style="padding: 10px;">
                            <h1 class="prop_card_name" style="font-weight: 500;" [ngStyle]="{'color': prop.property.status != 'occupied'? 'black' : prop.property.status == 'occupied' ? 'gray' : '#000'}"> {{ prop.property.name }}, {{prop.property.totalrooms}} BHK </h1>
                            <div class="prop_detail">
                                <p style="font-size: 14px; text-transform: capitalize; font-weight: 400;">{{ prop.property.formatted_details }} ...</p>
                            </div>
                            <div class="d-flex justify-content-between" style="margin-top: 10px; margin-bottom: 20px;">
                                <div>
                                    <!-- <p style="font-size: 14px; margin-bottom: 0; font-weight: 500;">Starts From</p> -->
                                    <p class="prop_card_rent">{{ prop.property.rent | currency:'INR':'symbol':'1.2'  }} </p> 
                                </div>
                                <p class="prop_card_loc"><fa-icon [icon]="faMapMarker" [ngStyle]="{'color' : prop.property.status == 'occupied' ? 'gray' : 'coral'}"></fa-icon> {{ prop.property.locality }} </p> 
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <p class="prop_card_gender" [ngStyle]="{'color' : prop.property.gender == 2 && prop.property.status != 'occupied'? '#339af0' : prop.property.status != 'occupied' && prop.property.gender == 1 ? '#339af0' : prop.property.status == 'occupied' ? 'gray' : 'lightseagreen' }">
                                    {{ prop.property.gender == 0?"Family/Full Property" : prop.property.gender == 1?"Co-Living": prop.property.gender == 2?"Co-Living": "" }} </p>
                                <p class="prop_card_status" [ngStyle]="{'color' : prop.property.status == 'partial' ? '#339af0' : prop.property.status == 'available' ? '#4BB543' : 'grey'  }">{{prop.property.status }}</p>

                            </div>
                            <p class="prop_card_footer" *ngIf="prop.property.golden == 1"[ngStyle]="{'color' : prop.property.golden == 1 && prop.property.status != 'occupied' ? '#d4af37' : 'gray'}">Golden Property</p>
                            <p class="prop_card_footer" *ngIf="prop.property.golden != 1"[ngStyle]="{'color' : prop.property.golden == 1 && prop.property.status != 'occupied' ? '#d4af37' : 'gray'}"></p>
                            
                            <!-- <hr style="margin-top: 0;">
                            <div class="prop_footer_wrapper">
                                <p class="prop_card_footer" *ngIf="prop.property.sharetype != 0">{{prop.property.sharetype == 1 ? 'Single' : prop.property.sharetype == 2 ? 'Shared' : ''}}</p>
                                <p class="prop_card_footer" *ngIf="prop.property.golden == 1"[ngStyle]="{'color' : prop.property.golden == 1 && prop.property.status != 'occupied' ? '#d4af37' : 'gray'}">{{prop.property.golden == 1 ? 'Golden Property' : ''}}</p>
                                
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>    
        </div>
        
        <!-- <div class="col-md-3">
            <div style="background-color: red; width: 320px;  height: 270px; "></div>
        </div>     -->
    </div>
    
</div>

<ng-template #scheduleVisit let-modal>
    <div class="row">
        <div class="col-md-4" style="background-color: #F9E316;">
            <div style="top: 50%; position: absolute; left: 50%; transform: translate(-50%, -50%); text-align: center;">
                <img src="assets/images/pay-logo.png" style="max-width: 100%; margin: auto;">
                <p style="font-size: 20px; font-weight: 500;"> Schedule Visit </p>
            </div>
            
        </div>
        <div class="col-md-8 p-4">
            <form role="form">
                <div class="form-group col-md-12">
                    <input type="text" placeholder="Name" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group col-md-12">
                    <input type="text" placeholder="Email" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group col-md-12">
                    <input type="text" placeholder="Phone" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group col-md-12">
                    <input type="date" placeholder="Date" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group col-md-12">
                    <input type="time" placeholder="HH:MM*" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group col-md-12">
                    <hr>
                </div>
                <div class="form-group col-md-12">
                    <p><b> *</b>You are required to pay a visit schedule charge of <b> &#x20B9; 50 </b> </p>
                </div>
                <div class="form-group col-md-12">
                    <button class="btn" style="background-color: #F9E316; border: none; color: black; font-weight: 600;"> Proceed for Payment </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>